import angular from 'angular';

class confirmationModalCtrl {
  /* @ngInject */
  constructor() {}

  $onInit() {
    this.modalConfirmButtonText = angular.copy(this.resolve.modalConfirmButtonText) || {value: 'commons.confirm'};
    this.modalTitle = angular.copy(this.resolve.modalTitle) || '';
    this.modalMessage = angular.copy(this.resolve.modalMessage);
    this.modalCancelButtonText = angular.copy(this.resolve.modalCancelButtonText) || {value: 'commons.cancel'};
    this.data = angular.copy(this.resolve.data) || null;
  }

  cancel() {
    this.modalInstance.dismiss(this.data);
  }

  confirm() {
    this.modalInstance.close(this.data);
  }

  showConfirm() {
    return this.modalConfirmButtonText && this.modalConfirmButtonText.value;
  }
}

angular.module('app.principal').component('confirmationModal', {
  templateUrl: require('./confirmation-modal.html'),
  controller: confirmationModalCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
